import { Scenarios } from '@jfs/network'

const resendVoucher = {
  default: [
    {
      url: /resendVoucher/,
      method: 'POST',
      response: { status: 'SUCCESS' },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /resendVoucher/,
      method: 'POST',
      responseCode: 5000,
      response: { responseCode: '1111', responseMessage: 'Invalid App Id Token Passed in header information' },
      delay: 1000,
    },
  ],
} as Scenarios

export { resendVoucher }
